<template>
  <div class="page">
    <div class="layout">
      <el-row type="flex" justify="space-between" align="middle">
        <el-col :span="12">
          <el-page-header @back="onBack" title="" content="設定 - 分校列表">
          </el-page-header>
        </el-col>
        <el-col :span="4" style="text-align: right;">
          <el-button type="info" @click="onAdd">新增分校</el-button>
        </el-col>
      </el-row>
      <div class="page-box">
        <div class="page-box-content">
          <div class="page-box-content-row">
            <div>
              <div class="search-text">中文名稱</div>
              <el-input
                v-model="from.nameZhLike"
                placeholder="請輸入中文名稱"
              ></el-input>
            </div>
            <div>
              <div class="search-text">英文名稱</div>
              <el-input
                v-model="from.nameEnLike"
                placeholder="請輸入英文名稱"
              ></el-input>
            </div>
            <div>
              <div class="search-text">分校名稱縮寫</div>
              <el-input
                v-model="from.abbreviationLike"
                placeholder="請輸入分校名稱縮寫"
              ></el-input>
            </div>
            <div>
              <el-button type="info" @click="onSearch" class="button-el-el">搜尋</el-button>
            </div>
            <div>
              <el-button type="success" @click="onEl" class="button-el-el">清除篩選</el-button>
            </div>
          </div>
        </div>

        <el-table
          @sort-change="handleSortChange"
          :data="tableData"
          style="width: 100%;"
        >
          <el-table-column label="#" type="index" align="center">
          </el-table-column>
          <el-table-column
            prop="nameZh"
            label="中文名稱"
            align="center"
            sortable="custom"
          
          >
          </el-table-column>
          <el-table-column
            prop="nameEn"
            label="英文名稱"
            align="center"
            sortable="custom"
         
          >
          </el-table-column>
          <el-table-column
            prop="abbreviation"
            label="分校名稱縮寫"
            align="center"
            sortable="custom"
        
          >
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" size="medium" @click="onDelete(row.id)"
                >删除</el-button
              >
              <el-button type="text" size="medium" @click="onEdit(row.id)">編輯</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { getBranchSchools, deleteBranchSchools } from "@/api/setting";
export default {
  data() {
    return {
      itemId: 0,
      centerDialogVisible: false,
      tableData: [],
      tableLabels: [
        {
          label: "課題標題",
          prop: "programTitle",
        },
        {
          label: "用戶點擊量",
          prop: "clickNum",
        },
        {
          label: "發佈時間",
          prop: "programReleaseAt",
        },
      ],
      from: {
        nameZhLike: null,
        nameEnLike: null,
        abbreviationLike: null,
        orderBy: null,
      },
    };
  },
  created() {
    this.getBranchSchools();
  },
  methods: {
    onAdd() {
      this.$router.push({ path: `/setting/addCourseUsageAnalysisReport` });
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.from.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.from.orderBy = column.prop + " asc";
      } else {
        this.from.orderBy = null;
      }
      this.getBranchSchools();
    },
    onEl(){
      Object.keys(this.from).forEach((key) => {
         this.from[key] = null
      })
      this.getBranchSchools()
    },
    onSearch() {
      this.getBranchSchools();
    },
    onDelete(id) {
      this.itemId = id;
      this.$confirm("是否刪除該分校?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.deleteBranchSchools();
      });
    },
    onEdit(id) {
      this.$router.push({
        path: `/setting/editCourseUsageAnalysisReport/${id}`,
      });
    },

    deleteBranchSchools() {
      deleteBranchSchools(this.itemId).then(() => {
        this.getBranchSchools();
      });
    },
    getBranchSchools() {
      let from = {
        nameZhLike: this.from.nameZhLike,
        nameEnLike: this.from.nameEnLike,
        abbreviationLike: this.from.abbreviationLike,
        orderBy: this.from.orderBy,
      };
      getBranchSchools(from).then((v) => {
        this.tableData = v.data;
        this.$store.dispatch("getBranchSchools");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
}
.page-box {
  background-color: #fff;
  margin-top: 20px;
  .el-row {
    padding: 20px;
  }
}
.button-el-el {
  width: 100%;
  margin-top: 20px;
}
.page-box-content{
  width: 100%;
  overflow-x: auto;
}
.page-box-content-row {
    display: grid;
    padding: 20px;
    grid-template-columns: repeat(5, 170px);
    grid-template-rows: repeat(1, 1fr);
    gap: 8px;
    align-items: end;
}
</style>